import "./EditVenue.scss";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import bin from "../../assets/images/icons/delete.svg";

import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import VenueInformation from "../../components/VenueInformation/VenueInformation";
import VenueCheckIns from "../../components/VenueCheckIns/VenueCheckIns";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function EditVenue() {
    const navigate = useNavigate();
    const { venueId } = useParams();

    const [venueInfoActive, setVenueInfoActive] = useState(true);
    const [checkInInfoActive, setCheckInInfoActive] = useState(false);

    const [specVenue, setSpecVenue] = useState({});

    useEffect(() => {
        const getVenue = async () => {
            try {
                const response = await axios.get(
                    `https://zona-app-server-584d567d8841.herokuapp.com/venues/${venueId}`
                );
                setSpecVenue(response.data);
            } catch (err) {
                console.log(`error retreiving specific venue. this was the error: ${err}`);
            }
        };
        getVenue();
    }, [venueId]);

    function handleSubNavClick(tab) {
        switch (tab) {
            case "venueInfo":
                setCheckInInfoActive(false);
                setVenueInfoActive(true);
                break;
            case "checkIns":
                setVenueInfoActive(false);
                setCheckInInfoActive(true);
                break;
            default:
                break;
        }
    }

    //DELETING VENUE ======================================================================

    function handleVenueDelete() {
        const deleteVenue = async () => {
            try {
                await axios.delete(`https://zona-app-server-584d567d8841.herokuapp.com/venues/${venueId}`);
                navigate("/venues");
            } catch (err) {
                console.log(`error deleting users. this was the error: ${err}`);
            }
        };
        deleteVenue();
    }

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="edit-venue">
                        <div className="edit-venue__top">
                            <div className="edit-venue__top-left">
                                <img
                                    onClick={() => navigate(-1)}
                                    className="edit-venue__top-left-icon"
                                    src={chevronLeft}
                                    alt="arrowhead pointing left"
                                ></img>

                                <h1 className="edit-venue__top-left-heading">Editing venue</h1>
                            </div>

                            <button onClick={handleVenueDelete} className="edit-venue__top-button">
                                <p className="edit-venue__top-button-text">Delete venue</p>
                                <img src={bin} alt="white garbage bin"></img>
                            </button>
                        </div>
                        <div className="edit-venue__sub-nav">
                            <div
                                onClick={() => handleSubNavClick("venueInfo")}
                                className={
                                    venueInfoActive
                                        ? "edit-venue__sub-nav-link edit-venue__sub-nav-link--active"
                                        : "edit-venue__sub-nav-link"
                                }
                            >
                                <p className="edit-venue__sub-nav-link-text">Venue Information</p>
                            </div>

                            <div
                                onClick={() => handleSubNavClick("checkIns")}
                                className={
                                    checkInInfoActive
                                        ? "edit-venue__sub-nav-link edit-venue__sub-nav-link--active"
                                        : "edit-venue__sub-nav-link"
                                }
                            >
                                <p className="edit-venue__sub-nav-link-text">Check Ins</p>
                            </div>
                        </div>

                        {venueInfoActive ? (
                            <VenueInformation specVenue={specVenue} />
                        ) : (
                            <VenueCheckIns specVenue={specVenue} />
                        )}
                    </section>
                </article>
            </div>
        </main>
    );
}

export default EditVenue;
